import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { Container } from '../../components/ui/Container';
import { GeometricAccent } from '../../components/ui/GeometricAccent';
import { MosqueArchMask } from '../../components/ui/MosqueArchMask';
import { PatternDecor } from '../../components/ui/PatternDecor';
type ProgramPrinciple = {
  title: string;
  body: string;
  tone: string;
};
const scholarshipSupport = ['الوصول إلى برامج الأطفال المنظمة', 'اشتراكات التعلّم عبر الإنترنت والأدوات الرقمية', 'جلسات الإرشاد والدعم التعليمي عند توفرها', 'مواد التعلّم وموارد الأسرة'];
const programPrinciples: ProgramPrinciple[] = [{
  title: 'تخصيص شفاف',
  body: 'معايير أهلية واضحة، وتمويل قائم على الشراكات، واختيار منظّم.',
  tone: 'bg-sage-100'
}, {
  title: 'استمرارية تعليمية',
  body: 'دعم يمتد لفصول متعددة كي يبقى الأطفال مسجلين ويتقدموا بلا انقطاع.',
  tone: 'bg-[#F7EDE9]'
}, {
  title: 'تقارير منتظمة',
  body: 'يتلقى المانحون والشركاء تحديثات عن النتائج والتخصيص والأثر.',
  tone: 'bg-sand-100'
}];
export function ArabicPartnershipScholarships() {
  return <div dir="rtl" className="overflow-hidden text-right" data-id="element-4687" data-mp="25e4onx9o1md8">
      <section className="relative isolate overflow-hidden" data-id="element-4688" data-mp="25fpifko5p1a1">
        <GeometricAccent variant="arabesque" className="absolute -right-20 top-6 hidden h-[420px] w-[420px] md:block" opacity={0.08} data-id="element-4689" data-mp="2abelvz3ar2bm" />
        <GeometricAccent variant="dots" className="absolute left-8 top-16 h-32 w-32" opacity={0.4} data-id="element-4690" data-mp="1vlp6ozydcxsc" />
        <Container className="relative pb-16 pt-8 md:pb-24 md:pt-12" data-id="element-4691" data-mp="20gmlkniby1d5">
          <div className="grid items-center gap-10 lg:grid-cols-12" data-id="element-4692" data-mp="1moom74ef7ju6">
            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            ease: [0.22, 1, 0.36, 1]
          }} className="lg:col-span-6" data-id="element-4693" data-mp="1rlf1hpieibej">
              <p className="text-sm font-semibold text-forest-700" data-id="element-4694" data-mp="1ho0vkju3t50h">ضمان تكافؤ الوصول واستمرارية التعليم</p>
              <h1 className="mt-3 font-display text-4xl font-semibold leading-[1.45] text-ink-900 sm:text-5xl lg:text-[3.5rem]" data-id="element-4695" data-mp="yj5jhw24goee">برنامج المنح الدراسية</h1>
              <div className="mt-6 max-w-xl space-y-3 text-base leading-loose text-ink-700 md:text-lg" data-id="element-4696" data-mp="tr4dgrvjrtwt">
                <p data-id="element-4697" data-mp="otvrshb6x7qt">يضمن برنامج المنح الدراسية ألا تمنع الظروف المالية الأطفال من الوصول إلى تعليم منظّم يراعي الثقافة.</p>
                <p data-id="element-4698" data-mp="jsoj8g1844j3">يتم التخصيص بشفافية، والمعايير واضحة، والتقارير منتظمة؛ كي تعرف الأسر والمانحون والشركاء ما الذي يحققه دعمهم.</p>
              </div>
              <div className="mt-8 flex flex-wrap gap-3" data-id="element-4699" data-mp="1ck84e5hdrsnq">
                <Link to="/ar/contact#general-inquiry" data-id="element-4700" data-mp="17k3s6rni9k3b"><Button variant="primary" size="lg" data-id="element-4701" data-mp="17j2f6hmxiniy">اطلب تفاصيل المنحة</Button></Link>
                <Link to="/ar/partnership/donate-for-children" data-id="element-4702" data-mp="12lsdo3m9mler"><Button variant="secondary" size="lg" data-id="element-4703" data-mp="12n3j07vd017z">ادعم المنح الدراسية</Button></Link>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.7,
            delay: 0.1,
            ease: [0.22, 1, 0.36, 1]
          }} className="relative lg:col-span-6" data-id="element-4704" data-mp="3nbhrcdb8g15v">
              <div className="relative aspect-[200/148] w-full lg:-mr-8 lg:w-[calc(100%+6rem)]" data-id="element-4705" data-mp="27s0mgfcum65e"><MosqueArchMask src="https://cdn.magicpatterns.com/uploads/5n1iBHyLaErd9TVUJZictm/Scholarships-5.jpg" alt="أسر مسلمة ومربّون يجتمعون مع الأطفال حول مواد تعليمية في فصل دراسي مضيء" data-id="element-4706" data-mp="2crdb95na5nam" /></div>
            </motion.div>
          </div>
        </Container>
      </section>

      <section className="relative isolate overflow-hidden bg-sage-50/60 py-16 md:py-24" data-id="element-4707" data-mp="2mgwwuj2dnv96">
        <PatternDecor side="right" y="top" size="lg" data-id="element-4708" data-mp="2qh72fum9cjni" />
        <Container data-id="element-4709" data-mp="2vhcxzlvneqav">
          <h2 className="font-display text-3xl font-semibold leading-[1.45] text-ink-900 md:text-5xl" data-id="element-4710" data-mp="2viwe9chb11cn">ما الذي تدعمه المنح الدراسية</h2>
          <p className="mt-5 max-w-3xl leading-loose text-ink-700" data-id="element-4711" data-mp="30ev6jb5r73ic">تدعم المنح الدراسية:</p>
          <ul className="mt-7 grid gap-x-10 gap-y-4 sm:grid-cols-2" data-id="element-4712" data-mp="115obmyn37lgg">
            {scholarshipSupport.map(item => <li key={item} className="flex items-start gap-3 leading-loose text-ink-700" data-id="element-4713" data-mp="1650z9lls8wk3"><CheckCircle2Icon size={18} className="mt-1 shrink-0 text-forest-700" strokeWidth={1.8} aria-hidden="true" data-id="element-4714" data-mp="2wiqr70zf3g5f" /><span data-id="element-4715" data-mp="2rkfgyp57n3mo">{item}</span></li>)}
          </ul>
        </Container>
      </section>

      <section className="bg-white/60 py-16 md:py-24" data-id="element-4716" data-mp="35jf9i7vug2o4">
        <Container data-id="element-4717" data-mp="31jehtljqhuz4">
          <h2 className="font-display text-3xl font-semibold leading-[1.45] text-ink-900 md:text-5xl" data-id="element-4718" data-mp="31ivaeyrpmozc">كيف يعمل البرنامج</h2>
          <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-4719" data-mp="2duc06dp3o24m">{programPrinciples.map((principle, index) => <PrincipleCard key={principle.title} principle={principle} index={index} data-id="element-4720" data-mp="28vr14hll3ohr" data-mpi={index} />)}</div>
          <div className="mt-8 rounded-2xl border border-sage-200 bg-sage-50 px-6 py-4 text-center" data-id="element-4721" data-mp="2mmw3vsk90wwb"><p className="leading-loose text-ink-500" data-id="element-4722" data-mp="2huvxbh9ob5qr">يرجى ملاحظة أن صندوق المنح لدينا يستند إلى الصدقة والمنح المؤسسية؛ ولا تُقبل الزكاة في هذه المرحلة.</p></div>
        </Container>
      </section>

      <section className="relative isolate overflow-hidden bg-[#EDF2F7]/60 py-16 md:py-24" data-id="element-4723" data-mp="1q4rjk1gf5gyi">
        <PatternDecor side="left" y="middle" size="md" data-id="element-4724" data-mp="1fzhtfx4rus7t" />
        <Container data-id="element-4725" data-mp="1fxyeqayrkp85">
          <h2 className="font-display text-2xl font-semibold leading-[1.45] text-ink-900 md:text-4xl" data-id="element-4726" data-mp="1kqrhwuel3pi4">من يمكنه التقدّم؟</h2>
          <p className="mt-5 max-w-4xl leading-loose text-ink-700" data-id="element-4727" data-mp="162mx9kvz13wp">تتوفر المنح الدراسية للأسر المسلمة التي تعيش في دول غير مسلمة وتواجه عوائق مالية أمام التعليم المنظّم. تُحجز بعض المقاعد عبر الشراكات المجتمعية. ويعتمد الاختيار على الاحتياج والتزام الأسرة ومدى ملاءمة البرنامج.</p>
        </Container>
      </section>

      <section className="relative isolate overflow-hidden bg-white/60 py-16 md:py-24" data-id="element-4728" data-mp="23okhpntwvjba">
        <PatternDecor side="right" y="bottom" size="md" data-id="element-4729" data-mp="1ot4p7n8zbvh0" />
        <Container data-id="element-4730" data-mp="1oupkjf34bifx">
          <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between" data-id="element-4731" data-mp="1tqwpp5nowpwt">
            <div className="max-w-xl" data-id="element-4732" data-mp="ddfxkiks689v"><h2 className="font-display text-3xl font-semibold leading-[1.45] text-ink-900 md:text-5xl" data-id="element-4733" data-mp="dc4vqoawbale">هل أنت مستعد للدعم؟</h2><p className="mt-5 leading-loose text-ink-700" data-id="element-4734" data-mp="id2bku8fnsjq">اختر الخيار الأنسب: التبرع أو المنح الدراسية أو الشراكة المؤسسية. سنرد سريعًا بالخطوات التالية.</p></div>
            <div className="flex flex-col gap-3 md:items-end" data-id="element-4735" data-mp="2fzbk9iy78ear"><p className="max-w-sm text-sm leading-loose text-ink-500" data-id="element-4736" data-mp="2g0mzcex3h8h6">تنبيه: نقبل الصدقة والمنح المؤسسية، ولا نقبل الزكاة في هذه المرحلة.</p><div className="flex flex-wrap gap-3" data-id="element-4737" data-mp="26a1s633cuvmn"><Link to="/ar/partnership/donate-for-children" data-id="element-4738" data-mp="26atl165kif98"><Button variant="primary" data-id="element-4739" data-mp="267xpfoh702ny">تبرّع</Button></Link><Link to="/ar/partnership/become-a-partner" data-id="element-4740" data-mp="21b7ax5l1df4n"><Button variant="secondary" data-id="element-4741" data-mp="21ca27em9tjl3">كن شريكًا</Button></Link></div></div>
          </div>
        </Container>
      </section>
    </div>;
}
function PrincipleCard({
  principle,
  index
}: {
  principle: ProgramPrinciple;
  index: number;
}) {
  return <motion.article initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    delay: index * 0.06
  }} className={`rounded-2xl border border-ink-900/5 p-6 shadow-soft ${principle.tone}`} data-id="element-4742" data-mp="1nbphgcwspdoy"><h3 className="font-display text-lg font-semibold leading-loose text-ink-900" data-id="element-4743" data-mp="3hn47kutpxf58">{principle.title}</h3><p className="mt-3 text-sm leading-loose text-ink-700" data-id="element-4744" data-mp="3p6naglmha34q">{principle.body}</p></motion.article>;
}